import React, { useEffect, useState } from 'react';
import {
    Box, Spinner, Text, useColorModeValue, useDisclosure, Grid, Flex,
    Modal,
    ModalBody,
    ModalCloseButton,
    ModalContent,
    ModalHeader,
    ModalOverlay,
    Tooltip,
    Badge,
    Heading,
    Table,
    Tbody,
    TableContainer,
    Thead,
    Td,
    Tr,
    Icon,
    useToast,
    SkeletonText,
    Skeleton,
    IconButton,
    HStack
} from '@chakra-ui/react';
import { useGetAdspressoAdsetsByCampainIdQuery, useRemoveAdspressoAdsetMutation } from 'store/adspresso/adspressoAdsetapi';
import SalesForm from './SalesForm';
import LeadsForm from './LeadsForm';
import { AddIcon, EditIcon, ViewIcon } from "@chakra-ui/icons";
import { useGetAdsetFormQuery } from 'store/campaigns/adsetFormApi';
import { MdDelete } from 'react-icons/md';
import DeleteConfirmationModal from 'components/genericForms/DeleteConfirmationModal';
import adsetMapping from '../../../utils/adsetMapping.json'
import { useSelector } from 'react-redux';
import { useGetBmAdAccountsDetailsQuery } from 'store/BmAccounts/bmAccountApi';
import AdvantagePlusShoppingSalesForm from './AdvantageShoppingSalesForm';
import AppPromotionForm from './AppPromotionForm';
import AwarenessForm from './AwarenessForm';
import EngagementForm from './EngagementForm';
import TrafficForm from './TrafficForm';
import CatalogueSalesForm from './CatalogueSalesForm';
import { FiEdit2 } from 'react-icons/fi';


function AdSetForm({ campaignData, onAdsetsData }) {

    const toast = useToast();

    const { isOpen: isCreateOpen, onOpen: onCreateOpen, onClose: onCreateClose } = useDisclosure();
    const { isOpen: isViewOpen, onOpen: onViewOpen, onClose: onViewClose } = useDisclosure();
    const { isOpen: isEditModalOpen, onOpen: onEditModalOpen, onClose: onEditModalClose } = useDisclosure();
    const [isModalOpen, setModalOpen] = useState(false);
    const [selectedAdset, setSelectedAdset] = useState(null);
    const [isEditing, setisEditing] = useState(false);
    const userInfo = useSelector((state) => state.auth?.userInfo);


    const addBoxBorder = useColorModeValue("gray.300", "purple.800");
    const addBoxHoverBackground = useColorModeValue("gray.50", "gray.700");
    const editIconColor = useColorModeValue("gray.600", "gray.400");
    const editIconHoverColor = useColorModeValue("gray.500", "gray.300");
    const adsetInfo = useColorModeValue("gray.800", "white");
    const borderColor = useColorModeValue("gray.400", "purple.400");

    const campaignType = campaignData?.objective;
    const smartPromotionType = campaignData && campaignData?.smart_promotion_type === 'AUTOMATED_SHOPPING_ADS';

    const id = campaignData?._id;
    const adsAccountIds = campaignData?.adsAccounts?.map(account => account?.adsAccountId) || [];

    const isCampaignReady = !!campaignData && campaignData?._id;

   const productCatalogId = isCampaignReady &&
        Array.isArray(campaignData?.promoted_object) &&
        campaignData.promoted_object.length > 0
            ? campaignData.promoted_object[0]?.product_catalog_id
            : undefined;

    const baseSkip = !(isCreateOpen || isEditModalOpen) || campaignType !== 'OUTCOME_SALES';

    const shouldSkipCatalogueSales = !isCampaignReady || baseSkip || !productCatalogId;
    const shouldSkipSales = !isCampaignReady || baseSkip || !!productCatalogId;

    // Only when NO product_catalog_id
    const { data: dataSales, error: errorSales, isLoading: isLoadingSales } = useGetAdsetFormQuery(
        { campaign_type: 'OUTCOME_SALES' },
        { skip: shouldSkipSales }
    );
    
    // Only when product_catalog_id is present
    const { data: dataCatalogueSales, error: errorCatalogueSales, isLoading: isLoadingCatalogueSales } = useGetAdsetFormQuery(
        {
        campaign_type: 'OUTCOME_SALES',
        promoted_object: { product_catalog_id: productCatalogId }
        },
        { skip: shouldSkipCatalogueSales }
    );
  
    const { data: dataLeads, error: errorLeads, isLoading: isLoadingLeads } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_LEADS' }, { skip: !(isCreateOpen || isEditModalOpen) || campaignType !== 'OUTCOME_LEADS' });
    const { data: dataAwareness, error: errorAwareness, isLoading: isLoadingAwareness } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_AWARENESS' }, { skip: campaignType !== 'OUTCOME_AWARENESS' });
    const { data: dataEngagement, error: errorEngagement, isLoading: isLoadingEngagement } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_ENGAGEMENT' }, { skip: campaignType !== 'OUTCOME_ENGAGEMENT' });
    const { data: dataTraffic, error: errorTraffic, isLoading: isLoadingTraffic } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_TRAFFIC' }, { skip: campaignType !== 'OUTCOME_TRAFFIC' });
    const { data: dataAppPromotions, error: errorAppPromotions, isLoading: isLoadingAppPromotions } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_APP_PROMOTION' }, { skip: campaignType !== 'OUTCOME_APP_PROMOTION' });
    const { data: dataAdvantageShopping, error: errorAdvantageShopping, isLoading: isLoadingAdvantageShopping } = useGetAdsetFormQuery({ campaign_type: 'OUTCOME_SALES', smart_promotion_type: 'AUTOMATED_SHOPPING_ADS' }, { skip: !(isCreateOpen || isEditModalOpen) || campaignType !== 'OUTCOME_SALES' || !smartPromotionType });
      
    const { data: adsetsListData, error: adsetsListError, isLoading: isLoadingadsetsList, isFetching: isFetchingAdsets, refetch } = useGetAdspressoAdsetsByCampainIdQuery(id, {
        skip: !id,
    });

    const { data: bmAdAccountsDetails, error:bmAdAccountError, isLoading: isBmAdAccountsLoading, refetch: bmAdAccountsDetailsRefetch } = useGetBmAdAccountsDetailsQuery(
        {
            adsAccounts: adsAccountIds,
        },
        { skip: !adsAccountIds.length }
    );

    const [removeAdspressoAdset, removeResponse] = useRemoveAdspressoAdsetMutation();

    useEffect(() => {
        if (campaignData) {
            refetch();
        }
    }, [campaignData]);

    useEffect(() => {
        if (adsetsListData) {
            onAdsetsData(adsetsListData); // Send adsets data back to the parent
        }
    }, [adsetsListData]);

    const handleViewAdset = (adset) => {
        setSelectedAdset(adset);
        onViewOpen();
    };

    const handleSaveSuccess = () => {
        refetch();
    };

    const renderForm = () => {
        if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataSales && bmAdAccountsDetails?.data) {
            return <SalesForm
                data={dataSales?.data}
                adsetsListData={adsetsListData}
                campaignData={campaignData}
                onClose={onCreateClose}
                isEditing={isEditing}
                selectedAdset={selectedAdset}
                selectedAdAccounts={bmAdAccountsDetails?.data}
                onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                onSaveSuccess={handleSaveSuccess}
            />
        } else if (campaignType === 'OUTCOME_SALES' && !smartPromotionType && dataCatalogueSales && bmAdAccountsDetails?.data) {
            return <CatalogueSalesForm
                data={dataCatalogueSales?.data}
                adsetsListData={adsetsListData}
                campaignData={campaignData}
                onClose={onCreateClose}
                isEditing={isEditing}
                selectedAdset={selectedAdset}
                selectedAdAccounts={bmAdAccountsDetails?.data}
                onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                onSaveSuccess={handleSaveSuccess}
                />;
        } else if (campaignType === 'OUTCOME_LEADS' && !smartPromotionType && dataLeads && bmAdAccountsDetails?.data) {
            return <LeadsForm
                data={dataLeads?.data}
                adsetsListData={adsetsListData}
                campaignData={campaignData}
                onClose={onCreateClose}
                isEditing={isEditing}
                selectedAdset={selectedAdset}
                selectedAdAccounts={bmAdAccountsDetails?.data}
                onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                onSaveSuccess={handleSaveSuccess}
            />
        } else if (campaignType === 'OUTCOME_SALES' && smartPromotionType && dataAdvantageShopping && bmAdAccountsDetails?.data) {
            return <AdvantagePlusShoppingSalesForm
                data={dataAdvantageShopping?.data}
                adsetsListData={adsetsListData}
                campaignData={campaignData}
                onClose={onCreateClose}
                isEditing={isEditing}
                selectedAdset={selectedAdset}
                selectedAdAccounts={bmAdAccountsDetails?.data}
                onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                onSaveSuccess={handleSaveSuccess}
            />
        } else if (campaignType === 'OUTCOME_AWARENESS' && !smartPromotionType && dataAwareness && bmAdAccountsDetails?.data) {
            return <AwarenessForm
                data={dataAwareness?.data}
                adsetsListData={adsetsListData}
                campaignData={campaignData}
                onClose={onCreateClose}
                isEditing={isEditing}
                selectedAdset={selectedAdset}
                selectedAdAccounts={bmAdAccountsDetails?.data}
                onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                onSaveSuccess={handleSaveSuccess}
            />
        } else if (campaignType === 'OUTCOME_APP_PROMOTION' && !smartPromotionType && dataAppPromotions && bmAdAccountsDetails?.data && campaignData) {
            return (
                <AppPromotionForm
                    data={dataAppPromotions?.data}
                    adsetsListData={adsetsListData}
                    campaignData={campaignData}
                    selectedAdset={selectedAdset}
                    isEditing={isEditing}
                    selectedAdAccounts={bmAdAccountsDetails?.data}
                    onClose={onCreateClose}
                    onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                    onSaveSuccess={handleSaveSuccess}
                />
            );
        } else if (campaignType === 'OUTCOME_ENGAGEMENT' && !smartPromotionType && dataEngagement && bmAdAccountsDetails?.data && campaignData) {
            return (
                <EngagementForm
                    data={dataEngagement?.data}
                    adsetsListData={adsetsListData}
                    campaignData={campaignData}
                    selectedAdset={selectedAdset}
                    isEditing={isEditing}
                    selectedAdAccounts={bmAdAccountsDetails?.data}
                    onClose={onCreateClose}
                    onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                    onSaveSuccess={handleSaveSuccess}
                />
            );
        } else if (campaignType === 'OUTCOME_TRAFFIC' && !smartPromotionType && dataTraffic && bmAdAccountsDetails?.data && campaignData) {
            return (
                <TrafficForm
                    data={dataTraffic?.data}
                    adsetsListData={adsetsListData}
                    campaignData={campaignData}
                    selectedAdset={selectedAdset}
                    isEditing={isEditing}
                    selectedAdAccounts={bmAdAccountsDetails?.data}
                    onClose={onCreateClose}
                    onEditModalClose={() => { setSelectedAdset(null); onEditModalClose(); }}
                    onSaveSuccess={handleSaveSuccess}
                />
            );
        }
        return null;
    };

    const handleDeleteAdset = (id) => {

        removeAdspressoAdset(id)
            .unwrap()
            .then(response => {
                toast({
                    position: "top-right",
                    title: "Ad set deleted",
                    status: "success",
                    duration: 4000,
                    isClosable: true,
                });
            })
            .catch(error => {
                toast({
                    position: "top-right",
                    title: "Error deleting Ad set",
                    status: "error",
                    description: error?.data?.message,
                    duration: 4000,
                    isClosable: true,
                });
            });
    };

    const confirmDelete = () => {
        if (selectedAdset) {
            handleDeleteAdset(selectedAdset);
            setModalOpen(false);
            setSelectedAdset(null);
        }
    };

    const renderAdsetsList = () => {
        if (isLoadingadsetsList) {
            return ( 
                <Box
                    p="20px"
                    w="100%"
                    minH={"150px"}
                >
                    <Skeleton height="20px" mb="10px" />
                    <SkeletonText noOfLines={2} spacing="4" />
                </Box>
            )
        }

        if (adsetsListData?.data.length > 0) {
            return adsetsListData.data.map((adset, index) => {
                let { _id, name, daily_budget, lifetime_budget, bid_strategy, billing_event, optimization_goal, destination_type, targeting, promoted_object } = adset;

                return (
                    <Flex
                        borderWidth={1}
                        borderColor={addBoxBorder}
                        borderRadius={5}
                        p={"20px"}
                        w='100%'
                        minH={"150px"}
                        justifyContent={"space-between"}
                        flexDirection={"column"}
                        key={_id}
                        pos={'relative'}
                    >
                        <Box>
                            <Heading as='h3' size={"sm"} mb={'10px'}>{name}</Heading>
                            <Box mb={'10px'}>
                                {/* <Text fontSize={'12px'} color={'gray.800'} fontWeight={'bold'}>Conversion location: </Text> */}
                                <Text fontSize={'14px'} color={adsetInfo} mb={'5px'}> {adsetMapping?.destinationTypes[destination_type]}</Text>
                            </Box>

                            <Box >
                                {/* <Text fontSize={'12px'} color={'gray.800'} fontWeight={'bold'}>Performance goal: </Text> */}
                                <Text fontSize={'12px'} color={adsetInfo} mb={'5px'}> {adsetMapping?.optimizationGoals[campaignType === 'OUTCOME_AWARENESS' ? 'AWARENESS' : destination_type]?.find(goal => goal.value === optimization_goal)?.label}</Text>
                            </Box>

                        </Box>
                        <Flex mt="20px" justify="space-between" align="center">
                            <HStack spacing={2} align="center">
                                <Tooltip label="View" fontSize="xs">
                                <IconButton
                                    aria-label="View"
                                    size="sm"
                                    variant="ghost"
                                    icon={<ViewIcon />}
                                    onClick={() =>
                                    handleViewAdset({ _id, name, daily_budget, lifetime_budget, bid_strategy, billing_event, optimization_goal, destination_type, targeting, promoted_object })
                                    }
                                />
                                </Tooltip>

                                {userInfo?.role === 'client' && (
                                <Tooltip label="Edit" fontSize="xs">
                                    <IconButton
                                        aria-label="Edit"
                                        size="sm"
                                        variant="ghost"
                                        icon={<EditIcon />}
                                        onClick={() => { setSelectedAdset(_id); setisEditing(true); onEditModalOpen(); }}
                                    />
                                </Tooltip>
                                )}
                            </HStack>

                            {userInfo?.role === 'client' && (
                                <Tooltip label="Delete" fontSize="xs">
                                <IconButton
                                    aria-label="Delete"
                                    size="sm"
                                    variant="ghost"
                                    icon={<MdDelete />}
                                    color="red.500"
                                    _hover={{ color: 'red.400', bg: 'transparent' }}
                                    onClick={() => { setSelectedAdset(_id); setModalOpen(true); }}
                                />
                                </Tooltip>
                            )}
                        </Flex>
                    </Flex>
                );
            });
        } else {
            return null;
        }
    };

    const handleCreateOpen = () => {
        setisEditing(false);
        onCreateOpen();
    };

    const anyFormLoading = isLoadingSales || isLoadingLeads || isLoadingAdvantageShopping || isLoadingAppPromotions || isLoadingAwareness || isLoadingEngagement || isLoadingTraffic || isLoadingCatalogueSales;
    const anyAdsetsLoading = isLoadingadsetsList || isFetchingAdsets;
    const anyLoading = anyFormLoading || anyAdsetsLoading;


    return (
        <>
            <DeleteConfirmationModal
                isOpen={isModalOpen}
                onClose={() => setModalOpen(false)}
                onConfirm={confirmDelete}
                message="Do you wish to proceed with deleting this Ad Set?"
            />

            {/* CREATE ADSET MODAL */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isCreateOpen}
                scrollBehavior={"inside"}
                onClose={onCreateClose}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                <ModalHeader>New Ad set</ModalHeader>
                <ModalCloseButton />
                <ModalBody>
                {(anyFormLoading) ? (
                    <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'80vh'}>
                        <Spinner />
                        <Text>Loading…</Text>
                    </Flex>
                    ) : (
                    errorSales || errorLeads || errorAdvantageShopping || errorAppPromotions || errorTraffic || errorAwareness || errorEngagement || adsetsListError || bmAdAccountError ? (
                        <Flex direction={'column'} gap={2} color={'red.500'}>
                            <Text fontWeight="bold">Error loading ad set data:</Text>
                            <Text fontSize="sm">
                                {errorSales?.data?.message ||
                                errorLeads?.data?.message ||
                                bmAdAccountError?.data?.message ||
                                errorAdvantageShopping?.data?.message ||
                                errorAppPromotions?.data?.message ||
                                errorTraffic?.data?.message ||
                                errorAwareness?.data?.message ||
                                errorEngagement?.data?.message ||
                                adsetsListError?.data?.message ||
                                "An unknown error occurred."}
                            </Text>
                        </Flex>
                    ) : (
                        renderForm()
                    )
                    )}
                </ModalBody>
                </ModalContent>
            </Modal>

            {/* EDIT ADSET MODAL */}
            <Modal
                size={"6xl"}
                isCentered={true}
                isOpen={isEditModalOpen}
                scrollBehavior={"inside"}
                onClose={() => { onEditModalClose(); setSelectedAdset(null); setisEditing(false); }}
                closeOnOverlayClick={false}
                closeOnEsc={false}
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Edit Ad set</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                    {(isLoadingSales || isLoadingLeads || isLoadingAdvantageShopping || isLoadingAppPromotions || isLoadingAwareness || isLoadingEngagement || isLoadingTraffic || isLoadingCatalogueSales ) ? (
                            <Flex justify="center" align="center" height="80vh">
                                <Spinner size="lg" />
                            </Flex>
                        ) : (
                            renderForm()
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            {/* VIEW ADSET MODAL */}
            <Modal
                size={"2xl"}
                isCentered={true}
                isOpen={isViewOpen}
                scrollBehavior={"inside"}
                onClose={() => {
                    setSelectedAdset(null)
                    onViewClose()
                }
                }
            >
                <ModalOverlay />
                <ModalContent>
                    <ModalHeader>Ad set Details</ModalHeader>
                    <ModalCloseButton />
                    <ModalBody>
                        {selectedAdset ? (
                            <Flex gap={2} flexDirection={'column'}>
                                <TableContainer>
                                    <Table variant='simple' size={"sm"}>
                                        <Thead>
                                            <Tr>
                                                <Td w={"240px"} color='gray.500'>Ad set name</Td>
                                                <Td>{selectedAdset?.name}</Td>
                                            </Tr>
                                        </Thead>
                                        <Tbody>
                                            {selectedAdset?.destination_type ?
                                                <Tr>
                                                    <Td w={"240px"} color='gray.500'>Conversion location</Td>
                                                    <Td>{adsetMapping?.destinationTypes[selectedAdset?.destination_type]}</Td>
                                                </Tr>
                                                : null}
                                            <Tr>
                                                <Td w={"240px"} color='gray.500'>Performance goal</Td>
                                                <Td> {adsetMapping?.optimizationGoals[campaignType === 'OUTCOME_AWARENESS' ? 'AWARENESS' : selectedAdset?.destination_type]?.find(goal => goal.value === selectedAdset?.optimization_goal)?.label}</Td>
                                            </Tr>
                                            {selectedAdset?.bid_strategy ?
                                                <Tr>
                                                    <Td w={"240px"} color='gray.500'>Bid strategy</Td>
                                                    <Td>{adsetMapping?.bidStrategies[selectedAdset?.bid_strategy]?.label}</Td>
                                                </Tr>
                                                : null}

                                            {selectedAdset?.daily_budget ? (
                                                <Tr>
                                                    <Td w={"240px"} color='gray.500'>Daily budget</Td>
                                                    <Td>{selectedAdset?.daily_budget / 100}</Td>
                                                </Tr>
                                            ) : selectedAdset?.lifetime_budget ?
                                                <Tr>
                                                    <Td w={"240px"} color='gray.500'>Lifetime budget</Td>
                                                    <Td>{selectedAdset?.lifetime_budget / 100}</Td>
                                                </Tr>
                                                : null}
                                            <Tr>
                                                <Td w={"240px"} color='gray.500'>When you are charged</Td>
                                                <Td>{selectedAdset?.billing_event?.charAt(0).toUpperCase() + selectedAdset?.billing_event?.slice(1).toLowerCase()}</Td>
                                            </Tr>
                                            {selectedAdset?.promoted_object?.length > 0 && selectedAdset?.destination_type !== "APP" ? (
                                                <Tr>
                                                    <Td w={"240px"} color='gray.500'>Pixel </Td>
                                                    <Td>
                                                        {selectedAdset?.promoted_object?.map((pixel, index) => (
                                                            <Box key={index + pixel?.adsAccountId} p={1}>
                                                                <Text>Ad Account: {pixel?.adsAccountId}</Text>
                                                                <Text>Pixel: {pixel?.pixel_id}</Text>
                                                                <Text>Event type: {pixel?.custom_event_type}</Text>
                                                            </Box>
                                                        ))}
                                                    </Td>
                                                </Tr>
                                            ) : null}

                                            <Tr>
                                                <Td w={"240px"} color='gray.500'>Status</Td>
                                                <Td>
                                                    <Badge colorScheme={selectedAdset?.status ? 'green' : 'red'}>
                                                        {selectedAdset?.status ? 'Active' : 'Inactive'}
                                                    </Badge>
                                                </Td>
                                            </Tr>
                                        </Tbody>
                                    </Table>
                                </TableContainer>
                            </Flex>
                        ) : (
                            <Text>No details available</Text>
                        )}
                    </ModalBody>
                </ModalContent>
            </Modal>

            <Box p={'20px'} height="100%" display="flex" flexDirection="column" borderColor={borderColor}>
                {(anyLoading) ? (
                    <Flex direction={'column'} gap={2} alignItems={'center'} justifyContent={'center'} h={'70vh'}>
                        <Spinner />
                        <Text>Loading…</Text>
                    </Flex>
                ) : (
                    <Box flex="1" overflowY="auto" display="flex" flexDirection="column" gap={2}>
                        {!anyAdsetsLoading && adsetsListData && adsetsListData?.data?.length === 0 && (
                            <Flex>
                                <Text>Create one or more Ad Sets for your campaign</Text>
                            </Flex>
                        )}

                        <Grid
                            templateColumns={{
                                base: "repeat(auto-fill, minmax(140px, 1fr))", 
                                md: "repeat(auto-fill, minmax(180px, 1fr))",  
                                lg: "repeat(auto-fill, minmax(200px, 1fr))",
                            }}
                            gap="20px"
                        >
                            {userInfo && userInfo.role === 'client' ? (
                                <>
                                    {(smartPromotionType && adsetsListData?.data && adsetsListData?.data?.length > 0) ? (null) : (
                                        <Flex
                                            borderWidth={1}
                                            borderColor={addBoxBorder}
                                            borderRadius={5}
                                            p={"20px"}
                                            w='100%'
                                            minH={"180px"}
                                            _hover={{
                                                bg: addBoxHoverBackground,
                                                cursor: "pointer",
                                            }}
                                            alignItems={"center"}
                                            justifyContent={"center"}
                                            flexDirection={"column"}
                                            onClick={handleCreateOpen}
                                        >
                                            <AddIcon boxSize={4} mb={2} />
                                            <Text size={"md"}>Add New</Text>
                                        </Flex>
                                    )}
                                </>
                            ) : (null)}
                            {renderAdsetsList()}
                        </Grid>
                    </Box>
                )}
            </Box>
        </>
    );
}

export default AdSetForm;
